import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'number_of_diverse_seasonal_workers'

export const dataPointDefinition = {
  retracedId: 'number_of_diverse_seasonal_workers',
  name: 'Number of diverse seasonal workers:',
  description:
    'Seasonal workers are those hired by the facility for a specific season or period of the year, typically linked to agricultural or production cycles.',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 37580,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
